class NetworkError {
  title?: string | null

  name?: string | null

  stack?: string | null

  requestedUrl?: string | null

  payload?: any

  statusCode?: any

  requestMethod?: any

  constructor(error?: NetworkError) {
    this.title = error?.name || ''
    this.name = error?.name || ''
    this.stack = error?.stack || ''
    this.requestedUrl = error?.requestedUrl || ''
    this.payload = JSON.stringify(error?.payload)
    this.statusCode = error?.statusCode || ''
    this.requestMethod = error?.requestMethod || ''
  }
}

export default NetworkError
